import { SentryClient } from "#lib/sentry";
import { GTMClient } from "#lib/gtm";
import { PostHogClient } from "#lib/posthog";
import { IAppConfig } from "#app.config";

export const initTrackers = (config: IAppConfig) => {
    // posthog is available everywhere and only inited
    PostHogClient.build(config);
    const sentry = SentryClient.build(config);
    const gtm = GTMClient.build(window);

    return { sentry, gtm };
};

export function clearConsoleLogs() {
    Object.keys(console).map((consoleProperty) => {
        if (console[consoleProperty] instanceof Function) {
            console[consoleProperty] = (...args) => {};
        }
    });
}
